<template>
    <div class="footer-content">
        <div class="title">
            <img src="../assets/logo-footer.webp" alt="logo" />
            <div class="text">SARAVANA COMPANY LIMITED</div>
        </div>
        <div class="bottom">
            <!-- <div class="item">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                <div class="text">+66 0855193237</div>
            </div> -->
            <div class="item">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                <div class="text">mobile@saravanagroup.com</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                <div class="text">8 ซอยรามอินทรา 55/8 แขวงท่าแร้ง เขตบางเขน กรุงเทพมหานคร</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon4.webp" alt="" class="icon">
                <div class="text">0105560082405</div>
            </div>
        </div>
        <div class="c">
            © 2026 Hak Cipta Milik SARAVANA COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 261px;
    background: #001E53;
    padding: 0 230px;
    box-sizing: border-box;

    .title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 21px;
        margin-bottom: 47px;

        img {
            width: 48px;
            height: 48px;
            object-fit: contain;
            margin-bottom: 8px;
        }

        .text {
            font-weight: bold;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 19px;
            text-shadow: 0px 1px 0px #333333;
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 14px;
        padding-bottom: 33px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.31);

        .item {
            display: flex;
            align-items: center;

            .icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 11px;
            }

            .text {
                max-width: 293px;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 20px;
                text-shadow: 0px 1px 0px #333333;
            }
        }
    }

    .c {
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
    }
}
</style>